import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { SearchableDropdownField } from 'ui-components/components/dropdown';

import messages from './messages';
import Global from '../../../../../../../../store/global-selectors';
import { INT_PARAMETER } from '../../../../../constants/parameter-name-for-update';
import style from '../style.module.less';

/**
 * @typedef {import('../../../../../types/automation-rule-types.d.ts').AutomationRuleActionInputValueProps} AutomationRuleActionInputValueProps
 */

const getOptionLabel = (option) => option.name;
const getOptionValue = (option) => option.shipFromId;

/**
 * @param {object} props
 * @param {AutomationRuleActionInputValueProps} props.inputValueProps
 * @param {(updatedProps: AutomationRuleActionInputValueProps) => void} props.onChange
 * @param {ReactNode} props.label
 * @returns {JSX.Element}
 */
export const ShipFromLocationSearchableDropdown = ({ inputValueProps, onChange, label }) => {
  const shipFroms = useSelector(Global.selectSellerShipFroms);

  const intl = useIntl();

  const updateSelectedShipFromLocation = useCallback(
    (value) => {
      onChange({
        [INT_PARAMETER]: Number.parseInt(value, 10),
      });
    },
    [onChange],
  );

  const selectedShipFromId = inputValueProps[INT_PARAMETER]?.toString();
  const placeholder = intl.formatMessage(messages.noOptionSelectedMessage);

  return (
    <div className={style['action-selector']}>
      <div>{label}</div>
      <SearchableDropdownField
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        onItemSelected={updateSelectedShipFromLocation}
        options={shipFroms}
        placeholder={placeholder}
        selectedItemValue={selectedShipFromId}
      />
    </div>
  );
};
